import { useEffect, useState } from "react";
import { Button, Container, Form, Row, Col } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { getMembers } from "../../controllers/user";
import { useAuth } from "../auth/AuthProvider";
import { addTeamMembers } from "../../controllers/org";
import { useToast } from "../toast/ToastContext";

function EquipoAddMembers({ teamId, etapaId, comunidadId, onEquiperoAddition }) {
  const [equiperos, setEquiperos] = useState([]);
  const [equiperosOptions, setEquiperosOptions] = useState([]);
  const { token } = useAuth();
  const showToast = useToast();

  useEffect(() => {
    loadMembers()
  }, []);

  async function loadMembers() {
    const d = await getMembers(token, {
      comunidad: comunidadId,
      etapa: etapaId
    });
    let options = d.rows.filter(m => !m.team_member);
    setEquiperosOptions(options);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    console.log(equiperos);
    try {
      const membershipIds = equiperos.map(m => m.membership_id);
      await addTeamMembers(teamId, membershipIds);
      if (typeof onEquiperoAddition === 'function') {
        onEquiperoAddition(equiperos);
      }
      loadMembers();
      setEquiperos([]);
      showToast({
        message: 'Se agregaron nuevos miembros al equipo correctamente.',
        bg: 'success',
        autohide: true,
        delay: 7000,
        title: 'Miembros agregados'
      });
    }
    catch(e) {
      showToast({
        message: 'Ocurrió un error al agregar miembros. Intenta de nuevo más tarde.',
        bg: 'danger',
        autohide: true,
        delay: 7000,
        title: 'Error al agregar miembros'
      });
    }
  }

  return <Container className="mb-5">
    <h1>Agregar miembros</h1>

    <Form onSubmit={handleSubmit}>
      <Row>
        <Col lg={6}>
          <Typeahead
            id="equiperos"
            labelKey="label"
            onChange={(selected) => {
              setEquiperos(selected);
            }}
            options={equiperosOptions}
            placeholder="Selecciona a los equiperos"
            renderMenuItemChildren={(option) => (
                <span>{option.label}</span>
            )}
            selected={equiperos}
            multiple={true}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col sm={3}>
          { !!equiperos.length && <Button type="submit">Agregar</Button> }
        </Col>
      </Row>
    </Form>
    
  </Container>;
}

export default EquipoAddMembers;
